// extracted by mini-css-extract-plugin
module.exports = {"paymentCardsWrapper":"PaymentCards_paymentCardsWrapper__sPQHf","stacked":"PaymentCards_stacked__49UhS","paymentCardItem":"PaymentCards_paymentCardItem__93ZBF"};